import React from 'react';
import FadeIn from './FadeIn';

export default function PageHero({ title, subtitle, image, tag }) {
  return (
    <section className="relative h-[60vh] min-h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-brand-charcoal">
        <img 
          src={image || "https://ik.imagekit.io/aeu02xvjgn/34-padua-hills-theatre-claremont-persian-wedding-photography.jpg"} 
          alt={title} 
          className="w-full h-full object-cover opacity-60" 
        />
      </div>
      <div className="relative z-10 text-center px-6 max-w-4xl pt-20">
        <FadeIn>
          {tag && (
            <span className="text-brand-bronze uppercase tracking-[0.4em] text-[10px] font-bold mb-6 block">
              {tag}
            </span>
          )}
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-brand-vintage mb-8 font-light leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="font-sans text-brand-vintage/90 text-lg font-light tracking-wide max-w-2xl mx-auto">
              {subtitle}
            </p>
          )}
        </FadeIn>
      </div>
    </section>
  );
}